import React from 'react';
import { Button } from 'react-bootstrap';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useAnda } from './AndaContext';
import './anda.scss';

export default function AndaChatButton() {
  const { chatOpen, openChat } = useAnda();

  if (chatOpen) return null;

  return (
    <Button
      className="anda-chat-button"
      variant="success"
      onClick={openChat}
      aria-label="開啟安答"
    >
      <AutoAwesomeIcon sx={{ fontSize: 18, mr: 0.5 }} />
      安答
    </Button>
  );
}
